export const STRINGS = {
  fr: {
    nav_about: "Le Cabinet",
    nav_services: "Expertises",
    nav_method: "Méthodologie",
    nav_clients: "Clients",
    nav_values: "Valeurs",
    nav_contact: "Contact",
    cta_start: "Démarrer un projet",
    hero_cta_secondary: "Découvrir nos expertises",
    hero_scroll: "Défiler",
    about_eyebrow: "Le Cabinet",
    services_eyebrow: "Ce que nous faisons",
    services_title: "Nos domaines d'expertise",
    services_sub: "Sept expertises complémentaires, un seul objectif : la réussite durable de vos projets.",
    method_eyebrow: "Comment nous travaillons",
    method_title: "Notre méthodologie",
    method_sub: "Cinq étapes éprouvées, de la première écoute à l'évaluation des résultats.",
    clients_eyebrow: "À qui nous nous adressons",
    clients_title: "Nos clients",
    clients_sub: "Des solutions adaptées à chaque structure, quelle que soit sa taille ou sa mission.",
    values_eyebrow: "Ce qui nous guide",
    values_title: "Nos valeurs",
    contact_eyebrow: "Contact confidentiel",
    form_name: "Nom complet",
    form_email: "Votre e-mail",
    form_subject: "Sujet (facultatif)",
    form_message: "Votre message",
    form_send: "Envoyer le message",
    form_sending: "Envoi en cours…",
    form_success: "Message envoyé ! Nous vous répondrons rapidement.",
    form_error: "Une erreur est survenue. Merci de réessayer.",
    form_note: "Vos messages sont strictement confidentiels : ils sont visibles uniquement par le cabinet.",
    footer_tagline: "Cabinet de conseil stratégique — Papeete, Tahiti",
    footer_nav: "Navigation",
    footer_contact: "Contact",
    footer_rights: "Tous droits réservés.",
    footer_admin: "Espace admin",
    login_title: "Espace Admin",
    login_sub: "Accès réservé au cabinet",
    login_email: "E-mail",
    login_password: "Mot de passe",
    login_button: "Se connecter",
    login_loading: "Connexion…",
    login_back: "Retour au site",
    login_error: "E-mail ou mot de passe incorrect",
    admin_messages: "Messages reçus",
    admin_content: "Contenu du site",
    admin_logout: "Déconnexion",
    admin_empty: "Aucun message pour le moment.",
    admin_mark_read: "Marquer lu",
    admin_mark_unread: "Marquer non lu",
    admin_delete: "Supprimer",
    admin_save: "Enregistrer",
    admin_saving: "Enregistrement…",
    admin_saved: "Contenu mis à jour",
    admin_save_error: "Erreur lors de l'enregistrement",
    admin_fr: "Français",
    admin_en: "Anglais",
    unread: "non lu",
    unread_plural: "non lus",
    admin_reply: "Répondre",
    admin_reply_placeholder: "Votre réponse (envoyée par e-mail à l'expéditeur)…",
    admin_reply_send: "Envoyer la réponse",
    admin_reply_sending: "Envoi…",
    admin_reply_sent: "Réponse envoyée par e-mail",
    admin_replied: "Répondu le",
    admin_cancel: "Annuler",
    admin_media: "Images & Vidéo",
    admin_media_hint: "Formats acceptés : JPG, PNG, WebP, GIF, MP4, WebM. Laissez le champ vide pour conserver l'image par défaut.",
    admin_upload: "Téléverser un fichier",
    admin_uploading: "Envoi du fichier…",
    video_eyebrow: "En images",
    admin_video_hint: "Collez un lien YouTube OU téléversez un fichier MP4/WebM. La section vidéo n'apparaît sur le site que si ce champ est rempli.",
    gallery_eyebrow: "Réalisations",
    footer_legal: "Mentions légales",
    admin_gallery: "Galerie",
    admin_stats: "Statistiques",
    admin_gallery_empty: "Aucune image pour le moment. Ajoutez vos plus belles réalisations !",
    admin_gallery_add: "Ajouter cette image",
    admin_caption_fr: "Légende (FR, facultatif)",
    admin_caption_en: "Légende (EN, facultatif)",
    stats_total: "Messages reçus au total",
    stats_unread: "Messages non lus",
    stats_chart_title: "Messages par mois — 6 derniers mois",
    cookie_text: "Ce site n'utilise que le strict nécessaire technique (mémorisation de votre langue). Aucun cookie publicitaire ni de suivi. Vos messages restent confidentiels.",
    cookie_accept: "J'accepte",
    cookie_decline: "Refuser",
    cookie_more: "En savoir plus",
    testimonials_eyebrow: "Témoignages",
    admin_testimonials: "Témoignages",
    admin_testimonials_empty: "Aucun témoignage pour le moment.",
    admin_testimonial_add: "Ajouter un témoignage",
    admin_testimonial_quote_fr: "Témoignage (FR)",
    admin_testimonial_quote_en: "Témoignage (EN)",
    admin_testimonial_author: "Nom de l'auteur·rice",
    admin_testimonial_role_fr: "Fonction / structure (FR)",
    admin_testimonial_role_en: "Fonction / structure (EN)",
    admin_edit: "Modifier",
    admin_editing: "Modification en cours — changez les champs puis enregistrez.",
    admin_gallery_reorder_hint: "Astuce : glissez-déposez les images pour changer leur ordre d'affichage sur le site.",
    admin_order_saved: "Ordre enregistré",
    admin_media_section: "Rubrique d'affichage",
    admin_slots_title: "Emplacements clés",
    admin_slots_hint: "Le logo s'affiche dans le menu et le pied de page ; l'image du hero en haut de la page d'accueil ; les autres images et la vidéo dans leurs rubriques respectives. Téléversez un fichier ou collez un lien, puis cliquez sur Enregistrer.",
    admin_design: "Design",
    design_sections: "Couleur de fond par section",
    design_text: "Textes",
    design_text_color: "Couleur du texte",
    design_font_title: "Police des titres",
    design_font_body: "Police du texte",
    design_font_scale: "Taille du texte",
    design_save: "Enregistrer le design",
    design_reset: "Réinitialiser",
    design_hint: "Les changements s'appliquent au site public dès l'enregistrement. Pensez à garder un bon contraste entre fond et texte.",
    design_accent: "Couleur des boutons et accents",
    design_presets: "Thèmes prédéfinis — métamorphose en un clic",
    nav_news: "Actualités",
    news_title: "Actualités",
    news_sub: "Les dernières nouvelles du cabinet.",
    news_all: "Toutes les actualités",
    news_empty: "Aucune actualité pour le moment.",
    admin_news: "Actualités",
    admin_news_add: "Publier une actualité",
    admin_news_title_fr: "Titre (FR)",
    admin_news_title_en: "Titre (EN)",
    admin_news_body_fr: "Texte (FR)",
    admin_news_body_en: "Texte (EN)",
    admin_news_image: "Image (facultatif)",
    admin_export: "Exporter (CSV)",
    news_published: "Publié le",
  },
  en: {
    nav_about: "The Firm",
    nav_services: "Expertise",
    nav_method: "Methodology",
    nav_clients: "Clients",
    nav_values: "Values",
    nav_contact: "Contact",
    cta_start: "Start a project",
    hero_cta_secondary: "Explore our expertise",
    hero_scroll: "Scroll",
    about_eyebrow: "The Firm",
    services_eyebrow: "What we do",
    services_title: "Our areas of expertise",
    services_sub: "Seven complementary expertises, one single goal: the lasting success of your projects.",
    method_eyebrow: "How we work",
    method_title: "Our methodology",
    method_sub: "Five proven steps, from first listening to results evaluation.",
    clients_eyebrow: "Who we serve",
    clients_title: "Our clients",
    clients_sub: "Solutions tailored to every organization, whatever its size or mission.",
    values_eyebrow: "What guides us",
    values_title: "Our values",
    contact_eyebrow: "Confidential contact",
    form_name: "Full name",
    form_email: "Your email",
    form_subject: "Subject (optional)",
    form_message: "Your message",
    form_send: "Send message",
    form_sending: "Sending…",
    form_success: "Message sent! We will get back to you shortly.",
    form_error: "Something went wrong. Please try again.",
    form_note: "Your messages are strictly confidential: only the firm can read them.",
    footer_tagline: "Strategic consulting firm — Papeete, Tahiti",
    footer_nav: "Navigation",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",
    footer_admin: "Admin area",
    login_title: "Admin Area",
    login_sub: "Restricted to the firm",
    login_email: "Email",
    login_password: "Password",
    login_button: "Sign in",
    login_loading: "Signing in…",
    login_back: "Back to the site",
    login_error: "Incorrect email or password",
    admin_messages: "Received messages",
    admin_content: "Site content",
    admin_logout: "Sign out",
    admin_empty: "No messages yet.",
    admin_mark_read: "Mark as read",
    admin_mark_unread: "Mark as unread",
    admin_delete: "Delete",
    admin_save: "Save",
    admin_saving: "Saving…",
    admin_saved: "Content updated",
    admin_save_error: "Error while saving",
    admin_fr: "French",
    admin_en: "English",
    unread: "unread",
    unread_plural: "unread",
    admin_reply: "Reply",
    admin_reply_placeholder: "Your reply (sent by email to the sender)…",
    admin_reply_send: "Send reply",
    admin_reply_sending: "Sending…",
    admin_reply_sent: "Reply sent by email",
    admin_replied: "Replied on",
    admin_cancel: "Cancel",
    admin_media: "Images & Video",
    admin_media_hint: "Accepted formats: JPG, PNG, WebP, GIF, MP4, WebM. Leave empty to keep the default image.",
    admin_upload: "Upload a file",
    admin_uploading: "Uploading…",
    video_eyebrow: "On video",
    admin_video_hint: "Paste a YouTube link OR upload an MP4/WebM file. The video section only appears on the site when this field is filled.",
    gallery_eyebrow: "Our work",
    footer_legal: "Legal notice",
    admin_gallery: "Gallery",
    admin_stats: "Statistics",
    admin_gallery_empty: "No images yet. Add your best work!",
    admin_gallery_add: "Add this image",
    admin_caption_fr: "Caption (FR, optional)",
    admin_caption_en: "Caption (EN, optional)",
    stats_total: "Total messages received",
    stats_unread: "Unread messages",
    stats_chart_title: "Messages per month — last 6 months",
    cookie_text: "This site only uses what is technically necessary (remembering your language). No advertising or tracking cookies. Your messages stay confidential.",
    cookie_accept: "Accept",
    cookie_decline: "Decline",
    cookie_more: "Learn more",
    testimonials_eyebrow: "Testimonials",
    admin_testimonials: "Testimonials",
    admin_testimonials_empty: "No testimonials yet.",
    admin_testimonial_add: "Add a testimonial",
    admin_testimonial_quote_fr: "Testimonial (FR)",
    admin_testimonial_quote_en: "Testimonial (EN)",
    admin_testimonial_author: "Author name",
    admin_testimonial_role_fr: "Role / organization (FR)",
    admin_testimonial_role_en: "Role / organization (EN)",
    admin_edit: "Edit",
    admin_editing: "Editing — change the fields then save.",
    admin_gallery_reorder_hint: "Tip: drag and drop images to change their display order on the site.",
    admin_order_saved: "Order saved",
    admin_media_section: "Display section",
    admin_slots_title: "Key placements",
    admin_slots_hint: "The logo appears in the menu and footer; the hero image at the top of the homepage; other images and the video in their respective sections. Upload a file or paste a link, then click Save.",
    admin_design: "Design",
    design_sections: "Background color per section",
    design_text: "Texts",
    design_text_color: "Text color",
    design_font_title: "Headings font",
    design_font_body: "Body font",
    design_font_scale: "Text size",
    design_save: "Save design",
    design_reset: "Reset",
    design_hint: "Changes apply to the public site as soon as you save. Keep a good contrast between background and text.",
    design_accent: "Buttons & accent color",
    design_presets: "Preset themes — one-click makeover",
    nav_news: "News",
    news_title: "News",
    news_sub: "The latest updates from the firm.",
    news_all: "All news",
    news_empty: "No news yet.",
    admin_news: "News",
    admin_news_add: "Publish a news item",
    admin_news_title_fr: "Title (FR)",
    admin_news_title_en: "Title (EN)",
    admin_news_body_fr: "Text (FR)",
    admin_news_body_en: "Text (EN)",
    admin_news_image: "Image (optional)",
    admin_export: "Export (CSV)",
    news_published: "Published on",
  },
};
